module.exports = require("@ember/render-modifiers/modifiers/will-destroy");